import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { ServiceFactory } from '../../../../../services/ServiceFactory';

interface Props {
  invoiceNumber: string;
  locale: string;
  enabled: boolean;
}

export default function useGetInvoicePaymentLinkQuery({
  invoiceNumber,
  locale,
  enabled,
}: Props): UseQueryResult<string> {
  const paymentService = ServiceFactory.createPaymentV2Service();

  return useQuery({
    queryKey: ['getInvoicePaymentLink', invoiceNumber],
    queryFn: () => paymentService.getPaymentInformationForInvoice(invoiceNumber, locale),
    enabled,
  });
}
